import React from "react";
import useSeo from "../hooks/useSeo";
import Accordion, { AccordionItem } from "../components/common/Accordion";

const FAQS = [
  { q: "What sizes do you offer?", a: "We stock S, M, L, XL and XXL. Check the Size Guide on each product page for placeholder measurements (final measurements to be confirmed)." },
  { q: "How do I place an order?", a: "Add items to your cart, tap Proceed to Order, enter your delivery details and place the order on WhatsApp. Our team will confirm availability and next steps." },
  { q: "How does shipping work?", a: "Shipping rates and delivery timelines will be confirmed with you at order via WhatsApp. (Editable placeholder — no shipping rules are configured yet.)" },
  { q: "Can I exchange an item?", a: "Exchange terms are being finalised. Please reach out on WhatsApp with your order details and we'll assist. (Editable placeholder.)" },
  { q: "What is your return policy?", a: "Our return / refund policy is being finalised and will be published soon. Contact us on WhatsApp for any queries in the meantime. (Editable placeholder.)" },
  { q: "How should I care for my t-shirt?", a: "As a general guide: machine wash cold inside out, do not bleach, tumble dry low and warm iron if needed. Final care instructions will be confirmed per product." },
];

const FAQ = () => {
  useSeo({ title: "FAQ", description: "Frequently asked questions about sizes, orders, shipping, exchanges, returns and product care at 9'One Store.", path: "/faq" });
  return (
    <div className="animate-fade-in">
      <div className="border-b border-ink">
        <div className="container-9one py-12">
          <p className="label-mono text-ink/50">Help Centre</p>
          <h1 className="mt-2 font-display text-5xl uppercase tracking-tight sm:text-7xl">FAQ</h1>
        </div>
      </div>
      <div className="container-9one max-w-3xl py-12">
        <Accordion>
          {FAQS.map((f, i) => (
            <AccordionItem key={i} title={f.q} defaultOpen={i === 0}>
              {f.a}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
